__turbopack_context__.v({
  "logo": "videoPlayer-module-scss-module__NUtBta__logo",
  "playButton": "videoPlayer-module-scss-module__NUtBta__playButton",
  "poster": "videoPlayer-module-scss-module__NUtBta__poster",
  "thumbnail": "videoPlayer-module-scss-module__NUtBta__thumbnail",
  "video": "videoPlayer-module-scss-module__NUtBta__video",
  "videoPlayer": "videoPlayer-module-scss-module__NUtBta__videoPlayer",
});
